var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4188_2536",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H36V36H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4188_2536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.352 3.63271H6.88256C6.3685 3.63271 5.95176 3.21596 5.95176 2.70198V1.45815C5.95176 0.944097 6.3685 0.527354 6.88256 0.527354H29.1175C29.6315 0.527354 30.0482 0.944097 30.0482 1.45815V2.70198C30.0482 3.21596 29.6315 3.63271 29.1175 3.63271H13.8183",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7847 35.4727H9.21533C8.58498 35.4727 8.07402 34.9616 8.07402 34.3313V29.612C8.07402 28.9817 8.58498 28.4707 9.21533 28.4707H26.7847C27.415 28.4707 27.926 28.9817 27.926 29.612V34.3313C27.926 34.9616 27.415 35.4727 26.7847 35.4727Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1521 28.4707C21.4959 26.6318 20.5393 24.2192 20.5393 21.6674V20.68",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4607 20.68V21.6674C15.4607 24.2192 14.5041 26.6318 12.8479 28.4707",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7724 33.194H24.5696C24.8466 33.194 25.071 32.9695 25.071 32.6926V31.2507C25.071 30.9738 24.8466 30.7493 24.5696 30.7493H11.4053C11.1284 30.7493 10.9039 30.9738 10.9039 31.2507V32.6926C10.9039 32.9695 11.1284 33.194 11.4053 33.194H19.3061",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57043 3.6327V7.48787C8.57043 13.0757 11.4723 18.2628 16.2341 21.1867C17.3174 21.8519 18.6826 21.8519 19.7659 21.1867C20.2486 20.8903 20.7119 20.5702 21.1553 20.2292",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5757 12.6566C27.1334 11.0149 27.4296 9.2719 27.4296 7.48786V3.63269",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.852 15.7426L10.0947 15.5728C8.43679 15.2012 6.93906 14.2661 5.87713 12.9399C4.86878 11.6805 4.2906 10.1145 4.23498 8.50497C4.23133 8.39999 4.31732 8.31351 4.42237 8.31351H8.59183",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57043 5.95624H4.16564C2.89643 5.95624 1.87127 6.99476 1.87324 8.2639C1.87676 10.4911 2.64492 12.6744 4.03704 14.4132C5.43239 16.1559 7.40051 17.3847 9.579 17.8729L13.0869 18.6594",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4081 8.31349H31.5777C31.6827 8.31349 31.7687 8.39997 31.7651 8.50502C31.7094 10.1145 31.1312 11.6805 30.1228 12.9398C29.8154 13.3239 29.4704 13.6738 29.0966 13.9881",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7025 15.7178C31.1602 15.324 31.5829 14.8878 31.9629 14.4131C33.3551 12.6744 34.1232 10.4911 34.1267 8.2639C34.1287 6.99469 33.1036 5.95624 31.8343 5.95624H27.4296",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6648 12.7711C26.9078 13.1493 27.3984 13.2808 27.7979 13.0747C28.3623 12.7839 29.0383 13.1742 29.0685 13.8083C29.0899 14.2573 29.4491 14.6165 29.898 14.6379C30.5322 14.6681 30.9226 15.3442 30.6316 15.9085C30.4256 16.308 30.5571 16.7986 30.9352 17.0416C31.4693 17.3848 31.4693 18.1656 30.9352 18.5088C30.5571 18.7518 30.4256 19.2424 30.6316 19.6419C30.9226 20.2062 30.5322 20.8823 29.898 20.9125C29.4491 20.9339 29.0899 21.293 29.0685 21.742C29.0383 22.3762 28.3623 22.7665 27.7979 22.4757C27.3984 22.2696 26.9078 22.4011 26.6648 22.7793C26.3215 23.3134 25.5408 23.3134 25.1976 22.7793C24.9546 22.4011 24.4639 22.2696 24.0645 22.4757C23.5002 22.7665 22.824 22.3762 22.7939 21.742C22.7726 21.293 22.4133 20.9339 21.9643 20.9125C21.3302 20.8823 20.9398 20.2062 21.2308 19.6419C21.4368 19.2424 21.3053 18.7518 20.9271 18.5088C20.393 18.1656 20.393 17.3848 20.9271 17.0416C21.3053 16.7986 21.4368 16.308 21.2308 15.9085C20.9398 15.3442 21.3302 14.6681 21.9643 14.6379C22.4133 14.6165 22.7726 14.2573 22.7939 13.8083C22.824 13.1742 23.5002 12.7839 24.0645 13.0747C24.4639 13.2808 24.9546 13.1493 25.1976 12.7711C25.5408 12.237 26.3215 12.237 26.6648 12.7711Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4805 17.7752C28.4805 19.1831 27.3392 20.3246 25.9312 20.3246C24.5232 20.3246 23.3818 19.1831 23.3818 17.7752C23.3818 16.3673 24.5232 15.2258 25.9312 15.2258C27.3392 15.2258 28.4805 16.3673 28.4805 17.7752Z",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7385 22.5703V26.1384C23.7385 26.3012 23.9154 26.4021 24.0555 26.3195L25.8245 25.2773C25.8904 25.2385 25.9721 25.2385 26.0379 25.2773L27.8068 26.3195C27.947 26.4021 28.1238 26.3012 28.1238 26.1384V22.5703",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrIcon);
export default __webpack_public_path__ + "static/media/R&RIcon.1c5fc9b2e1f906a51583b5d840e528fc.svg";
export { ForwardRef as ReactComponent };